import {
  Box,
  Stack,
  Typography,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { PaymentMethodOptionStyles } from "./PaymentMethodOption.styles";

export interface IProps {
  label: string;
  description: string;
  icon?: string;
}

export const PaymentMethodOption = ({ label, description, icon }: IProps) => {
  const sx = PaymentMethodOptionStyles();

  return (
    <Stack
      direction="row"
      gap={1}
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
    >
      <Box>
        <Typography variant="h6" sx={sx.content.label}>
          {label}
        </Typography>
        <Typography variant="subtitle2" sx={sx.content.description}>
          {description}
        </Typography>
      </Box>
      {icon && <img src={icon} height="24px" alt="payment-method-icon" />}
    </Stack>
  );
};
